<template>
  <div id="log-agendamento">
    <vuestic-widget headerText="Agendamentos Realizados">
      <div v-if="!loaded">
        <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
          <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
            <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80">
            </component>
          </div>
        </div>
      </div>

      <div v-else>
        <div class="row">
          <div class="col-md-3">
            <button class="btn btn-micro btn-info seachButtons" @click="openModal">
              <i class="fa fa-download"></i>
              Relátorio
            </button>
          </div>
        </div>

        <form class="mt-5 mb-5 form" @submit.prevent="handleConsult">
          <div class="row mb-3">
            <fieldset class="col-md-3 inputs">
              <legend>Auto Escola</legend>
              <model-select :options="selectCFC" v-model="autoescola" placeholder="Selecione uma auto escola"
                ref="autoescola">
                <option>Selecione uma função</option>
              </model-select>
            </fieldset>

            <fieldset class="col-md-3 inputs" id="nome">
              <legend>Aluno</legend>
              <input type="text" class="form-control pl-2 border rounded" id="nome_aluno" v-model="inputs.aluno"
                placeholder="Nome" />
            </fieldset>

            <fieldset class="col-md-3" id="inicioProcesso">
              <legend>Data aula inicial</legend>
              <input type="date" class="form-control border rounded pl-2 pr-2" v-model="inputs.initialPeriod" />
            </fieldset>

            <fieldset class="col-md-3" id="inicioProcesso">
              <legend>Data aula final</legend>
              <input type="date" class="form-control border rounded pl-2 pr-2" v-model="inputs.finalPeriod" />
            </fieldset>
          </div>

          <div class="row">
            <fieldset class="col-md-3 inputs" id="nome">
              <legend>E-mail Usuário</legend>
              <input type="text" class="form-control pl-2 border rounded" id="nome_aluno" v-model="inputs.email"
                placeholder="E-mail" />
            </fieldset>

            <div class="col-md-3 d-flex align-items-end">
              <button type="submit" class="btn btn-block btn-micro btn-info seachButtons" :disabled="table.load">
                <template v-if="table.load">
                  <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
                    <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                      <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="17">
                      </component>
                    </div>
                  </div>
                </template>

                <template v-else>
                  <i class="fa fa-search"></i>
                  Consultar
                </template>
              </button>
            </div>

            <div class="col-md-3 d-flex align-items-end">
              <button type="button" class="btn btn-block btn-micro btn-danger seachButtons" :disabled="table.load"
                @click="clearInputs">
                <template v-if="table.load">
                  <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
                    <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                      <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="17">
                      </component>
                    </div>
                  </div>
                </template>

                <template v-else>
                  <i class="fa fa-trash"></i>
                  Limpar
                </template>
              </button>
            </div>
          </div>
        </form>

        <div class="row">
          <div class="col mx-auto">
            <pagination :source="pagination" @navigate="navigate" class="pagination justify-content-center">
            </pagination>
          </div>
        </div>

        <table class="table table-striped table-bordered table-responsive-sm text-center">
          <thead>
            <tr>
              <th>Auto Escola</th>
              <th>Aluno</th>
              <th>Log</th>
              <th>Data da Aula</th>
              <th>Usuário</th>
              <th>Data do agendamento</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="table.load">
              <tr>
                <td colspan="7" class="text-center">
                  <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
                    <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                      <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="50">
                      </component>
                    </div>
                  </div>
                </td>
              </tr>
            </template>

            <template v-else>
              <tr v-if="table.data.length === 0">
                <td colspan="6" class="text-center">Nenhum registro encontrado.</td>
              </tr>
              <tr v-else v-for="(dados, index) in table.data" :key="index">
                <td>{{ dados.schema }}</td>
                <td>{{ dados.aluno }}</td>
                <td>{{ dados.mensagem }}</td>
                <td>{{ utils.formatDate(dados.data) }}</td>
                <td>{{ dados.usuario }}</td>
                <td>{{ utils.formatDate(dados.dataMarcacao) }}</td>
              </tr>
            </template>
          </tbody>
        </table>

        <div class="row">
          <div class="col mx-auto">
            <pagination :source="pagination" @navigate="navigate" class="pagination justify-content-center">
            </pagination>
          </div>
        </div>
      </div>
    </vuestic-widget>

    <vuestic-modal :show.sync="modal.show" ref="fileModal" v-bind:small="false" cancelClass="none" okClass="none">
      <vuestic-tabs :names="['PDF', 'XLSX']" ref="tabs">
        <div slot="PDF">
          <div class="row justify-content-center">
            <div v-if="downloadPDFLoading" class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
              <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="55"></component>
              </div>
            </div>
            <button v-else class="btn btn-primary" @click="downloadFilePDF" :disabled="downloadPDFLoading">Download
              PDF</button>
          </div>
        </div>

        <div slot="XLSX">
          <div class="row justify-content-center">
            <div v-if="downloadXLSXLoading" class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
              <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="55"></component>
              </div>
            </div>

            <button v-else class="btn btn-primary" @click="downloadFileXLSX">Download XLSX</button>
          </div>
        </div>
      </vuestic-tabs>
    </vuestic-modal>
  </div>
</template>

<script>
import urlApi from '@/router/urlApiV2.js'
import * as spinners from 'epic-spinners'
import utils from '../../../../services/utils'
import { ModelSelect } from 'vue-search-select'
import pagination from '../../../pagination/pagination'

export default {
  name: 'LogAgendamento',
  components: {
    ...spinners,
    ModelSelect,
    pagination,
  },
  data() {
    return {
      utils: utils,
      autoescola: '',
      modal: {
        show: false,
        load: false,
      },
      inputs: {
        aluno: '',
        initialPeriod: '',
        finalPeriod: '',
        email: '',
      },
      table: {
        currentPage: '',
        data: '',
        firstPageUrl: '',
        from: '',
        lastPage: '',
        lastPageUrl: '',
        nextPageUrl: '',
        path: '',
        perPage: '',
        prevPageUrl: '',
        to: '',
        total: '',
        pages: [],
        load: false
      },
      selectCFC: [],
      loaded: false,
      pagination: '',
    }
  },
  async created() {
    await this.loadCfcs()

    this.loaded = true
  },
  methods: {
    async loadCfcs() {
      let selectCFC = []

      await this.$http.get(`${urlApi}/autoescola`)
        .then(response => {
          response.data.dados.map(autoescolas => {
            if (autoescolas.nome_fantasia !== '!TESTE') {
              selectCFC.push({
                value: autoescolas.tenant_schema,
                text: autoescolas.nome_fantasia,
              })
            }
          })
        })

      this.selectCFC = selectCFC
    },
    async handleConsult() {
      this.autoescola = this.autoescola ? this.autoescola : ''

      await this.loadData()
    },
    async loadData() {
      this.table.load = true
      this.pagination = ''

      const filters = `nome=${this.inputs.aluno}&periodoI=${this.inputs.initialPeriod}&periodoF=${this.inputs.finalPeriod}&email=${this.inputs.email}`
      this.filters = filters

      const consult = `${urlApi}/logs/relatorios/schedule?schema=${this.autoescola}&${filters}`
      this.consult = consult

      await this.$http.get(consult)
        .then(this.callbackDataPaginate)
        .catch(err => {
          this.$toasted.show('Erro ao buscar logs.', {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.table.load = false
        })
    },
    callbackDataPaginate(response) {
      let responseData = response.body.dados

      if (!responseData.data.length) {
        this.$toasted.show('Nenhum log encontrado.', {
          position: 'top-right',
        })
      }

      this.table.currentPage = responseData.current_page
      this.table.data = responseData.data
      this.table.firstPageUrl = responseData.first_page_url
      this.table.from = responseData.from
      this.table.lastPage = responseData.last_page
      this.table.lastPageUrl = responseData.last_page_url
      this.table.nextPageUrl = responseData.next_page_url
      this.table.path = responseData.path
      this.table.perPage = responseData.per_page
      this.table.prevPageUrl = responseData.prev_page_url
      this.table.to = responseData.to
      this.table.total = responseData.total

      this.table.pages = []
      for (let i = 1; i <= (responseData.last_page); i++) {
        this.table.pages.push(i)
      }

      this.items = this.table.data

      this.table.load = false

      this.pagination = responseData
    },
    async navigate(page) {
      this.table.load = true

      await this.$http.get(`${this.consult}&page=${page}`)
        .then(this.callbackDataPaginate)
        .catch(err => {
          this.$toasted.show('Erro ao buscar logs.', {
            position: 'top-right',
          })
        })
    },
    async downloadFilePDF() {
      this.downloadPDFLoading = true

      if (this.table.data.length < 1) {
        this.$toasted.show('Consulte na tabela de logs antes de baixar o PDF.', {
          position: 'top-right',
        })

        this.downloadPDFLoading = false

        return
      }

      if (this.autoescola === '') {
        this.$toasted.show('Selecione uma auto escola para gerar o relatório.', {
          position: 'top-right',
        })

        this.downloadPDFLoading = false

        return
      }

      await this.$http.get(`${urlApi}/logs/relatorios/schedule/pdf?schema=${this.autoescola}&${this.filters}`)
        .then(response => {
          const pdf = `data:application/octet-stream;base64,${response.body.dados}`;

          const link = document.createElement('a');
          link.download = 'relatorio-logs-agendamentos.pdf';
          link.href = pdf;

          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
        })
        .catch(err => {
          this.$toasted.show('Erro ao fazer o download do relatório.', {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.downloadPDFLoading = false
        })
    },
    async downloadFileXLSX() {
      this.downloadXLSXLoading = true

      if (this.table.data.length < 1) {
        this.$toasted.show('Consulte na tabela de logs antes de baixar o XLSX.', {
          position: 'top-right',
        })

        this.downloadXLSXLoading = false

        return
      }

      await this.$http.get(`${urlApi}/logs/relatorios/schedule/xlsx?schema=${this.autoescola}&${this.filters}`)
        .then(response => {
          const csv = `data:text/csv;charset=utf-8,${response.body.dados}`
          const link = document.createElement('a')
          link.setAttribute('href', encodeURI(csv))
          link.setAttribute('download', 'relatorio-logs-agendamentos.csv')
          document.body.append(link)
          link.click()
          link.remove()
        })
        .catch(err => {
          console.log(err)
          this.$toasted.show('Erro ao fazer o download do relatório.', {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.downloadXLSXLoading = false
        })
    },
    clearInputs() {
      const select = this.$refs.autoescola
      select.selectItem({
        value: '',
        text: ''
      })

      this.autoescola = ''

      this.inputs = {
        aluno: '',
        initialPeriod: '',
        finalPeriod: '',
        email: '',
      }

      this.filters = ''
    },
    openModal() {
      this.$refs.fileModal.open()
    },
  },
}

</script>